import { StateUtils } from '@spartacus/core';
import { SearchPageResultState } from '../../../../core/features/store/base-feature-state';
import { AssignedShipToPage } from '../../../../core/model';
import { getAvailableShipToUniqueId } from '../../utils/available-ship-to-utils';
import { SoldToActions } from '../actions';
import { AvailableShipTosActionTypes } from '../actions/sold-to-available-ship-tos.action';

export const initialState: SearchPageResultState = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer(state = initialState, action: SoldToActions.AvailableShipTosActions | StateUtils.LoaderAction): any {
  switch (action.type) {
    case AvailableShipTosActionTypes.LoadAvailableShipTosSuccess: {
      const payload: AssignedShipToPage = action.payload;

      const results = payload.results.map((availableShipTo) => getAvailableShipToUniqueId(availableShipTo));

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    default: {
      return state;
    }
  }
}
